export default class ClickToSubmit {
    constructor(element) {
        this.$element = $(element);
        this.$target = $(this.$element.data('clickToSubmit'));
        this.action = this.$element.data('action');
    }

    submit() {
        if (this.$target.length) {
            if (this.action !== undefined) {
                this.$target.attr('action', this.action);
            }
            this.$target.trigger('submit');
        } else {
            if (this.action !== undefined) {
                this.changeLocation(this.action);
            }
        }

    }

    changeLocation(url) {
        window.location.href = url;
    }

    init() {
        this.$element
            .off('click.clickToSubmit', '', $.proxy(this, 'submit'))
            .on('click.clickToSubmit', '', $.proxy(this, 'submit'));
    }
}